import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c890a5a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  style: {"float":"right","margin-top":"-2px"}
}
const _hoisted_4 = { style: {"font-size":"14px","padding":"0px 14px"} }
const _hoisted_5 = { class: "icons" }
const _hoisted_6 = { class: "icons" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  style: {"float":"right","text-align":"right"}
}
const _hoisted_9 = { style: {"font-size":"14px","padding":"0px 14px"} }
const _hoisted_10 = { class: "icons" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "icons" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "clearfix questionwrap" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle question" }, "问", -1))
const _hoisted_16 = { class: "info" }
const _hoisted_17 = {
  key: 0,
  class: "clearfix answerwrap"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle answer" }, "答", -1))
const _hoisted_19 = { class: "info" }
const _hoisted_20 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_21 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Askcollapse = _resolveComponent("Askcollapse")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["content", _ctx.theme])
  }, [
    _createElementVNode("section", null, [
      _createElementVNode("h3", null, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("span", {
            style: {"cursor":"pointer"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotodetail(_ctx.titleInfo)))
          }, _toDisplayString(_ctx.titleInfo.Inst ? _ctx.titleInfo.Inst : _ctx.titleInfo.code), 513), [
            [_vShow, _ctx.titleInfo.Inst || _ctx.titleInfo.code]
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle(_ctx.titleInfo.type != 'all' ? 'cursor: pointer;' : ''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.titleInfo.Inst ? _ctx.gotodetail(_ctx.titleInfo) : 'return')),
            class: _normalizeClass({ 'joined': _ctx.titleInfo.type === 'gp' && (_ctx.inOptionalData.indexOf(_ctx.titleInfo.Inst + '.' + (_ctx.titleInfo.Exch || '').toLowerCase()) > -1) }),
            innerHTML: _ctx.titleInfo.Name
          }, null, 14, _hoisted_2),
          _withDirectives(_createElementVNode("span", {
            style: {"cursor":"pointer"},
            class: _normalizeClass(_ctx.titleInfo.increase > 0 ? 'red' : _ctx.titleInfo.increase < 0 ? 'green' : ''),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotodetail(_ctx.titleInfo)))
          }, _toDisplayString(_ctx.getNumber2(_ctx.titleInfo.LastPrice)), 3), [
            [_vShow, _ctx.titleInfo.type !== 'all']
          ]),
          _withDirectives(_createElementVNode("span", {
            style: {"cursor":"pointer"},
            class: _normalizeClass(_ctx.titleInfo.increase > 0 ? 'red' : _ctx.titleInfo.increase < 0 ? 'green' : ''),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotodetail(_ctx.titleInfo)))
          }, _toDisplayString(_ctx.titleInfo.increase > 0 ? '+' : '') + _toDisplayString(_ctx.getPencent(_ctx.titleInfo.increase)), 3), [
            [_vShow, _ctx.titleInfo.type !== 'all']
          ]),
          (!_ctx.isDYZT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.titleInfo.type === 'gp')
                  ? (_openBlock(), _createBlock(_component_a_popover, {
                      key: 0,
                      placement: "bottomRight",
                      destroyTooltipOnHide: "",
                      trigger: "click",
                      overlayClassName: _ctx.treeData.length ? 'optionalSharesPop' : 'optionalSharesPop nodata',
                      overlayStyle: { 'width': '200px' },
                      getPopupContainer: _ctx.getPopupContainer,
                      onVisibleChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.visibleChange($event, _ctx.titleInfo, _ctx.i)))
                    }, {
                      content: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_4, " 已添加自选！可选择分组", 512), [
                          [_vShow, (_ctx.inOptionalData.indexOf(_ctx.titleInfo.Inst + '.' + (_ctx.titleInfo.Exch || '').toLowerCase()) > -1)]
                        ]),
                        _withDirectives(_createVNode(_component_a_divider, null, null, 512), [
                          [_vShow, (_ctx.inOptionalData.indexOf(_ctx.titleInfo.Inst + '.' + (_ctx.titleInfo.Exch || '').toLowerCase()) > -1)]
                        ]),
                        _createVNode(_component_a_tree, {
                          checkable: "",
                          "tree-data": _ctx.treeData,
                          "replace-fields": _ctx.optionalSharesProps,
                          checkedKeys: _ctx.checkedKeys,
                          "onUpdate:checkedKeys": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkedKeys) = $event)),
                          onCheck: _cache[5] || (_cache[5] = (event, checked) => _ctx.handleOptionalShares(event, checked, _ctx.titleInfo, _ctx.i))
                        }, null, 8, ["tree-data", "replace-fields", "checkedKeys"])
                      ]),
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", {
                            class: "add",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addOptionalShares(null, _ctx.titleInfo, _ctx.i)))
                          }, _toDisplayString('+ 加自选'))
                        ], 512), [
                          [_vShow, !(_ctx.inOptionalData.indexOf(_ctx.titleInfo.Inst + '.' + (_ctx.titleInfo.Exch || '').toLowerCase()) > -1)]
                        ])
                      ]),
                      _: 1
                    }, 8, ["overlayClassName", "getPopupContainer"]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "remove",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeOptionalShares(null, _ctx.titleInfo, null, _ctx.i)))
                  }, "— 删自选")
                ], 512), [
                  [_vShow, (_ctx.inOptionalData.indexOf(_ctx.titleInfo.Inst + '.' + (_ctx.titleInfo.Exch || '').toLowerCase()) > -1)]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_a_spin, {
        tip: "加载中...",
        spinning: _ctx.loading,
        wrapperClassName: _ctx.PageID !== 1 && _ctx.loading ? 'bottomloading' : ''
      }, {
        default: _withCtx(() => [
          (_ctx.cardList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["cardwrap", { 'datawrap': !_ctx.allloaded }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_a_card, {
                    key: item.ID,
                    bordered: false
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("p", null, [
                            (_openBlock(), _createBlock(_component_Askcollapse, {
                              content: item.QContent,
                              key: _ctx.askcollapsekey,
                              sign: 'ask',
                              lineclamp: 5
                            }, null, 8, ["content"]))
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", null, _toDisplayString(item.QAuthor), 1),
                            _createElementVNode("span", null, _toDisplayString(item.QTime), 1)
                          ])
                        ]),
                        (item.AContent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("p", null, [
                                (_openBlock(), _createBlock(_component_Askcollapse, {
                                  content: item.AContent,
                                  key: _ctx.askcollapsekey,
                                  sign: 'ask',
                                  lineclamp: 5
                                }, null, 8, ["content"]))
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", null, _toDisplayString(item.ATime), 1),
                                _createElementVNode("span", null, "来源：" + _toDisplayString((item.Exch || '').toLowerCase() === 'sz' ? '深交所互动易' : (item.Exch || '').toLowerCase() ===
                    'sh' ?
                    '上交所互动易' : '全景网'), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, [
                    (_ctx.titleInfo.type !== 'gp')
                      ? {
                          name: "title",
                          fn: _withCtx(() => [
                            _createElementVNode("label", {
                              onClick: ($event: any) => (_ctx.gotodetail(item))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.Inst), 1),
                              _createElementVNode("span", {
                                style: {"margin-right":"20px"},
                                class: _normalizeClass({ 'joined': (_ctx.inOptionalData.indexOf(item.Inst + '.' + (item.Exch || '').toLowerCase()) > -1) })
                              }, _toDisplayString(item.Name), 3),
                              _createElementVNode("span", {
                                style: {"margin-right":"14px"},
                                class: _normalizeClass(item.increase > 0 ? 'red' : item.increase < 0 ? 'green' : '')
                              }, _toDisplayString(_ctx.getNumber2(item.LastPrice)), 3),
                              _createElementVNode("span", {
                                class: _normalizeClass(item.increase > 0 ? 'red' : item.increase < 0 ? 'green' : '')
                              }, _toDisplayString(item.increase > 0 ? '+' : '') + " " + _toDisplayString(_ctx.getPencent(item.increase)), 3)
                            ], 8, _hoisted_7),
                            (!_ctx.isDYZT)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_openBlock(), _createBlock(_component_a_popover, {
                                    placement: "bottomRight",
                                    key: _ctx.tablepopoverkey[item.Inst + '' + i],
                                    destroyTooltipOnHide: "",
                                    trigger: 'click',
                                    forceRender: "",
                                    style: {"width":"200px"},
                                    overlayClassName: _ctx.treeData.length ? 'optionalSharesPop' : 'optionalSharesPop nodata',
                                    getPopupContainer: _ctx.getPopupContainer,
                                    onVisibleChange: (visible) => _ctx.visibleChange(visible, item, i, _ctx.$event)
                                  }, {
                                    content: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", _hoisted_9, " 已添加自选！可选择分组", 512), [
                                        [_vShow, (_ctx.inOptionalData.indexOf(item.Inst + '.' + (item.Exch || '').toLowerCase()) > -1)]
                                      ]),
                                      _withDirectives(_createVNode(_component_a_divider, null, null, 512), [
                                        [_vShow, (_ctx.inOptionalData.indexOf(item.Inst + '.' + (item.Exch || '').toLowerCase()) > -1)]
                                      ]),
                                      (_ctx.visibleInst[item.Inst + '' + i])
                                        ? (_openBlock(), _createBlock(_component_a_tree, {
                                            key: 0,
                                            checkable: "",
                                            selectable: false,
                                            "tree-data": _ctx.treeData,
                                            "replace-fields": _ctx.optionalSharesProps,
                                            checkedKeys: _ctx.checkedKeys,
                                            "onUpdate:checkedKeys": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedKeys) = $event)),
                                            onCheck: (event, checked) => _ctx.handleOptionalShares(event, checked, item, i)
                                          }, null, 8, ["tree-data", "replace-fields", "checkedKeys", "onCheck"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", {
                                          class: "add",
                                          onClick: ($event: any) => (_ctx.addOptionalShares(null, item, i))
                                        }, _toDisplayString('+ 加自选'), 8, _hoisted_11)
                                      ], 512), [
                                        [_vShow, !(_ctx.inOptionalData.indexOf(item.Inst + '.' + (item.Exch || '').toLowerCase()) > -1)]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["overlayClassName", "getPopupContainer", "onVisibleChange"])),
                                  _withDirectives(_createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", {
                                      class: "remove",
                                      onClick: ($event: any) => {_ctx.visibleFlag = true; _ctx.removeOptionalShares(null, item, null, i)}
                                    }, "— 删自选", 8, _hoisted_13)
                                  ], 512), [
                                    [_vShow, (_ctx.inOptionalData.indexOf(item.Inst + '.' + (item.Exch || '').toLowerCase()) > -1)]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024))
                }), 128))
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_Nodata, {
                  class: "cardwrap",
                  mode: "vertical",
                  customdesc: '暂无问答'
                })
              ]))
        ]),
        _: 1
      }, 8, ["spinning", "wrapperClassName"])
    ]),
    _createVNode(_component_a_modal, {
      class: "tipsmodal",
      wrapClassName: "tipsmodalwrap",
      zIndex: 0,
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalVisible) = $event)),
      "ok-text": "",
      "cancel-text": "",
      footer: null,
      content: null,
      mask: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/tips.svg'),
            alt: ""
          }, null, 8, _hoisted_21),
          _createElementVNode("span", null, "已为您发现" + _toDisplayString(_ctx.updateIndex) + "条新问答", 1),
          _createElementVNode("span", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.freshdata && _ctx.freshdata(...args)))
          }, "点此更新")
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}